import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'

import { ProfileCircle, Home2, ShoppingCart, Category2 } from 'iconsax-react'

import styles from './styles.module.css'

import { useQuery } from '@tanstack/react-query'
import { GetUserCart } from 'services/cart'

const BottomTabs = () => {
  const location = useLocation()

  const { isAuthorized, user } = useSelector(
    ({ auth }) => ({ isAuthorized: auth.user != null, user: auth.user }),
    shallowEqual,
  )
  const { uuid } = useSelector(({ common }) => ({
    uuid: common.uuid,
  }))

  const { data: cart } = useQuery({
    queryKey: ['[List] carts'],
    queryFn: () =>
      GetUserCart(isAuthorized ? {} : { uuid: uuid }).then((result) => result),
  })

  const tabs = [
    {
      title: 'خانه',
      url: '/store',
      icon: (type) => <Home2 variant={type} />,
    },
    {
      title: 'دسته بندی',
      url: '/categories',
      icon: (type) => <Category2 variant={type} />,
    },
    {
      title: 'سبد خرید',
      url: '/cart',
      icon: (type) => <ShoppingCart variant={type} />,
      badge: cart?.cart_items_count,
    },
    {
      title: 'پروفایل',
      url: '/profile',
      icon: (type) => <ProfileCircle variant={type} />,
    },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {tabs.map((tab, index) => (
          <Link
            key={`tab-${index}`}
            className={
              location.pathname.includes(tab.url)
                ? styles.active_item
                : styles.nav_item
            }
            to={tab.url}
          >
            {tab.icon(location.pathname.includes(tab.url) ? 'Bold' : 'Outline')}
            <span>{tab.title}</span>
            {tab.badge && tab.badge > 0 ? (
              <div className={styles.badge}>{tab.badge}</div>
            ) : (
              <></>
            )}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default BottomTabs
